var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count < 2)?_c('div',{staticClass:"p-4 analytics-loading"},[_c('b-spinner',{attrs:{"variant":"primary"}})],1):_c('vue-apex-charts',{attrs:{"type":"line","height":"240","options":_vm.options,"series":_vm.series}})}
var staticRenderFns = []

export { render, staticRenderFns }